import { i18next, initReactI18next } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 47633, offsets 282434:504107. Structure and names inferred from code, not screenshots.
import * as LocaleContext from "./I18nProvider.jsx";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as GetLanguageModule from "./getLanguage.js";
import c from "../locales/zh/announcement.json";
import d from "../locales/zh/api.json";
import u from "../locales/zh/authCheck.json";
import p from "../locales/zh/authSetting.json";
import m from "../locales/zh/authority.json";
import h from "../locales/zh/banner.json";
import g from "../locales/zh/common.json";
import f from "../locales/zh/console.json";
import M from "../locales/zh/contact.json";
import y from "../locales/zh/footer.json";
import x from "../locales/zh/home.json";
import N from "../locales/zh/invite.json";
import b from "../locales/zh/nav.json";
import k from "../locales/zh/pages.json";
import T from "../locales/zh/pricing.json";
import C from "../locales/zh/profile.json";
import w from "../locales/zh/quickStart.json";
import A from "../locales/zh/schema.json";
import D from "../locales/zh/sidebar.json";
import j from "../locales/zh/tokenPlan.json";
import v from "../locales/zh/tokenPlanCalculator.json";
import I from "../locales/zh/mimo-v2.5-pro.json";
import P from "../locales/zh/mimo-v2.5.json";
import S from "../locales/zh/mimo-v2.5-asr.json";
import z from "../locales/zh/mimo-v2.5-tts.json";
import L from "../locales/zh/mimo-v2.5-tts-voicedesign.json";
import E from "../locales/zh/mimo-v2.5-tts-voiceclone.json";
import O from "../locales/zh/mimo-v2.6-pro.json";
import U from "../locales/zh/mimo-v2.6-flash.json";
import _ from "../locales/zh/mimo-v2.6-pro-ultraspeed.json";
import eX from "../locales/zh/gpt-6-astra.json";
import eJ from "../locales/zh/claude-opus-5-5.json";
import eD from "../locales/zh/kimi-k3.json";
import eH from "../locales/zh/deepseek-v4-1-flash.json";
import V from "../locales/zh/tps.json";
import F from "../locales/zh/user.json";
import Y from "../locales/zh/chat.json";
import R from "../locales/en/announcement.json";
import B from "../locales/en/api.json";
import Q from "../locales/en/authCheck.json";
import q from "../locales/en/authSetting.json";
import Z from "../locales/en/authority.json";
import K from "../locales/en/banner.json";
import G from "../locales/en/common.json";
import H from "../locales/en/console.json";
import W from "../locales/en/contact.json";
import $ from "../locales/en/footer.json";
import X from "../locales/en/home.json";
import J from "../locales/en/invite.json";
import ee from "../locales/en/nav.json";
import et from "../locales/en/pages.json";
import ei from "../locales/en/pricing.json";
import en from "../locales/en/profile.json";
import eo from "../locales/en/quickStart.json";
import ea from "../locales/en/schema.json";
import er from "../locales/en/sidebar.json";
import el from "../locales/en/tokenPlan.json";
import es from "../locales/en/tokenPlanCalculator.json";
import ec from "../locales/en/mimo-v2.5-pro.json";
import ed from "../locales/en/mimo-v2.5.json";
import eu from "../locales/en/mimo-v2.5-asr.json";
import ep from "../locales/en/mimo-v2.5-tts.json";
import em from "../locales/en/mimo-v2.5-tts-voicedesign.json";
import eh from "../locales/en/mimo-v2.5-tts-voiceclone.json";
import eg from "../locales/en/mimo-v2.6-pro.json";
import ef from "../locales/en/mimo-v2.6-flash.json";
import eM from "../locales/en/mimo-v2.6-pro-ultraspeed.json";
import eG from "../locales/en/gpt-6-astra.json";
import eK from "../locales/en/claude-opus-5-5.json";
import eL from "../locales/en/kimi-k3.json";
import eR from "../locales/en/deepseek-v4-1-flash.json";
import ey from "../locales/en/tps.json";
import ex from "../locales/en/user.json";
import eN from "../locales/en/chat.json";
i18next.use(initReactI18next).init({
  resources: {
    zh: {
      translation: {
        announcement: c,
        api: d,
        authCheck: u,
        authSetting: p,
        authority: m,
        banner: h,
        common: g,
        console: f,
        contact: M,
        footer: y,
        home: x,
        invite: N,
        nav: b,
        pages: k,
        pricing: T,
        profile: C,
        quickStart: w,
        schema: A,
        sidebar: D,
        tokenPlan: j,
        tokenPlanCalculator: v,
        "mimo-v2.5-pro": I,
        "mimo-v2.5": P,
        "mimo-v2.5-asr": S,
        "mimo-v2.5-tts": z,
        "mimo-v2.5-tts-voicedesign": L,
        "mimo-v2.5-tts-voiceclone": E,
        "mimo-v2.6-pro": O,
        "mimo-v2.6-flash": U,
        "mimo-v2.6-pro-ultraspeed": _,
        "gpt-6-astra": eX,
        "claude-opus-5-5": eJ,
        "kimi-k3": eD,
        "deepseek-v4-1-flash": eH,
        tps: V,
        user: F,
        chat: Y,
      },
    },
    en: {
      translation: {
        announcement: R,
        api: B,
        authCheck: Q,
        authSetting: q,
        authority: Z,
        banner: K,
        common: G,
        console: H,
        contact: W,
        footer: $,
        home: X,
        invite: J,
        nav: ee,
        pages: et,
        pricing: ei,
        profile: en,
        quickStart: eo,
        schema: ea,
        sidebar: er,
        tokenPlan: el,
        tokenPlanCalculator: es,
        "mimo-v2.5-pro": ec,
        "mimo-v2.5": ed,
        "mimo-v2.5-asr": eu,
        "mimo-v2.5-tts": ep,
        "mimo-v2.5-tts-voicedesign": em,
        "mimo-v2.5-tts-voiceclone": eh,
        "mimo-v2.6-pro": eg,
        "mimo-v2.6-flash": ef,
        "mimo-v2.6-pro-ultraspeed": eM,
        "gpt-6-astra": eG,
        "claude-opus-5-5": eK,
        "kimi-k3": eL,
        "deepseek-v4-1-flash": eR,
        tps: ey,
        user: ex,
        chat: eN,
      },
    },
  },
  lng: (0, GetLanguageModule.getLanguage)(),
  fallbackLng: "zh",
  defaultNS: "translation",
  interpolation: {
    escapeValue: false,
  },
});
let AppProviders = ({ children: children }) => (
  <LocaleContext.I18nProvider>
    <AnalyticsContext.AnalyticsProvider>
      {children}
    </AnalyticsContext.AnalyticsProvider>
  </LocaleContext.I18nProvider>
);
export { AppProviders };
